import React, { PureComponent } from "react";
import { connect } from "react-redux";
import _ from "i18n";
import {
  setCurrentNavPage,
  setSubMenuDirection,
  setSubMenuDirectionToggle
} from "Actions";
import CollaboratorSpace from "./CollaboratorSpace";
import { HORIZONTAL, VERTICAL } from "Config";
import { getURLWithoutHeaderParam } from "Utils";
import { inIframe } from "../../utils";
import { NotificationBar } from "../Common/Notification/NotificationBar";

class CollaboratorSpacePage extends PureComponent {
  constructor(props) {
    super(props);
    let { uen } = this.props.match.params;

    this.state = { organizationUen: uen, withoutHeader: false };
  }

  componentWillMount() {
    const { location } = this.props;
    const { withoutHeader } = getURLWithoutHeaderParam(location);

    this.setState({ withoutHeader: withoutHeader });
  }

  componentDidMount() {
    const { dispatch, subMenuDirection } = this.props;

    dispatch(setCurrentNavPage("COLLABORATOR_SPACE"));

    if (subMenuDirection === VERTICAL) {
      dispatch(setSubMenuDirection(HORIZONTAL));
    }
    dispatch(setSubMenuDirectionToggle(true));

    let { uen } = this.props.match.params;
    this.setState({ organizationUen: uen });
  }

  render() {
    let { id, year } = this.props.match.params;
    const { withoutHeader } = this.props;
    return (
      <div className={`page-content`} style={{ display: "contents" }}>
        {inIframe() === false && (
          <div
            style={{
              marginBottom: "10px"
            }}
          >
            <NotificationBar
              message={_("notifyUsingUa")}
              isUaNotification={true}
              theme="lightOrange"
            />
          </div>
        )}
        <CollaboratorSpace
          id={id}
          paramYear={year}
          withoutHeader={withoutHeader}
        />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  currentOrganization: state.auth.currentOrganization,
  withoutHeader: state.auth.withoutHeader
});

export default connect(mapStateToProps)(CollaboratorSpacePage);



// WEBPACK FOOTER //
// ./src/components/CollaboratorSpace/CollaboratorSpacePage.js